import { SIDEBAR_KEY } from '../actions/sidebar.types';

export const sidebarState = state => state[SIDEBAR_KEY];

export const sidebarVisible = state => sidebarState(state).visible;



// WEBPACK FOOTER //
// ./src/store/reducers/sidebar.selectors.js